const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

let initialized = false;

/**
 * Carrega gtag.js e configura GA4 quando VITE_GA_MEASUREMENT_ID está definido (ex.: G-XXXXXXXXXX).
 */
export function initGoogleAnalytics() {
  if (!GA_ID || initialized) return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

/**
 * Envia evento customizado para o GA4 (somente se o GA estiver configurado).
 */
export function trackGaEvent(eventName, params = {}) {
  if (!GA_ID || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
}
